import React, {Component} from 'react'
import { Tabs, Tab, Container, Row, Col} from 'react-bootstrap'
import { IoIosArrowForward } from "react-icons/io";

import TripsList from '../components/TripsList'

class Trips extends Component {
   render() {
      return (
         <div>
           <TripsList></TripsList>
       </div>
      )
   }
}


export default Trips;